import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='bg-gray-800 text-white'>
    <div className='md:flex text-left w-full justify-around
    p-8'>
    <div>
    <p className='font-medium text-red-500'>26th – 28th November 2026</p>

<p className='font-semibold text-md text-blue-100'>2nd International Conference on <br/> Computational Technologies for Research in Data Analytics <br/>(ICCTRDA-2026)</p>
{/* <p className='font-medium text-red-500'>Duy Tan University, Da Nang,Vietnam</p> */}
    </div>
        <div>
          <h3 className='text-lg text-blue-100'>Links:</h3>
          <ul className='text-md font-light'>
            <li><Link to={'/'}>Home</Link></li>
            <li><Link to={'/registrations'}>Registrations</Link></li>
            <li><Link to={'/downloads'}>Downloads</Link></li>
            <li><Link to={'https://cmt3.research.microsoft.com/ICCTRDA2026'}>Paper Submission</Link></li>
          </ul>
        </div>
        <div>
          <h3 className='text-lg text-blue-100'>Contact us:</h3>
          <ul className='font-light text-md'>
            <li>Email: <a href='mailto:Support@icctrda.com'>Support@icctrda.com</a><br/>
            <a href='mailto:icctrda.congress@gmail.com'>icctrda.congress@gmail.com</a></li>
            
           
          </ul>
        </div>
        {/* <div>
          <h3>Social Media</h3>
          <div>
            <a href=''><img /></a>
          </div>
        </div> */}
    </div>
    <p className='text-sm text-center'>The Microsoft CMT service was used for managing the peer-reviewing process for this conference.<br/>
This service was provided for free by Microsoft and they bore all expenses, including costs for Azure cloud services as well as for software development and support.</p>
    </div>
  )
}

export default Footer